import { render, staticRenderFns } from "./TrainingQualificationDetails.vue?vue&type=template&id=2be5c11e&scoped=true"
import script from "./TrainingQualificationDetails.vue?vue&type=script&lang=ts"
export * from "./TrainingQualificationDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be5c11e",
  null
  
)

export default component.exports